t = require('views/internal/teacup-with-helpers')('header_logo')

module.exports = t.renderable (headerBrandingLogo) ->
  t.a '.header-logo.js-home-via-logo', { class: t.classify('has-branding': headerBrandingLogo), href: '/', 'aria-label': t.l('trello-home') }, ->
    if headerBrandingLogo
      t.img '.header-branding-logo', { src: headerBrandingLogo }
    t.span '.header-logo-loading'
    t.span '.header-logo-default'


// WEBPACK FOOTER //
// ./app/scripts/views/templates/header_logo.coffee